// src/components/Auth/GoogleLoginButton.js
import React, { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
//import { auth } from '../../firebase/firebase'; // Import auth from your firebase.js
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import googleLogo from '../../assets/google-icon-logo.svg';

const GoogleLoginButton = () => {
    const { googleLogin } = useContext(AuthContext); // Consume googleLogin from AuthContext
    const navigate = useNavigate(); // Get navigate for redirection

    const handleGoogleSignIn = async () => {
        try {
            await googleLogin(); // Directly call googleLogin from context
            navigate('/dashboard'); // Redirect to dashboard after successful login
        } catch (error) {
            console.error("Google Sign-in Error:", error);
            alert(`Google Sign-in failed: ${error.message}`);
        }
    };

    return (
        <Button variant="danger" onClick={handleGoogleSignIn}>
            <div className='gooogle-logo-wrap'>
                <img src={googleLogo} alt='' />
            </div>
            Sign in with Google
        </Button>
    );
};

export default GoogleLoginButton;